import { httpClient } from "@/helpers/httpClient";
import User from "@/models/application/User";
export default class {
    resource = "/api/application";
    async getUser() {
        const response = await httpClient.get(`${this.resource}/user`);
        if (response.isAuthenticated) {
            return new User(response.name, response.userType, response.isAuthenticated, response.permissions, response.locationId, response.locationName, response.nexusUserId);
        }
        else
            return new User(undefined, undefined, false, undefined, 0, undefined, undefined);
    }
    async getUserDepartmentHierarchy(nexusUserId) {
        const response = await httpClient.get(`${this.resource}/${nexusUserId}/userdepartmenthierarchy`);
        return response;
    }
    async getReportCategories(userDepartmentHierarchy) {
        const response = await httpClient.post(`${this.resource}/reportcategories`, userDepartmentHierarchy);
        return response;
    }
    async getManualOverrides(nexusUserId) {
        const response = await httpClient.get(`${this.resource}/reportcategories/overrides/${nexusUserId}`);
        return response;
    }
    async getUserLocation(nexusUserId) {
        const response = await httpClient.get(`${this.resource}/${nexusUserId}/userlocation`);
        return response;
    }
    async getLocationOverrides(nexusUserId) {
        const response = await httpClient.get(`${this.resource}/${nexusUserId}/userlocation/overrides`);
        return response;
    }
}
